import http from '../_http_v2';

const report = {
  report: (m) => { return http.post(`console/webcastle/report`, m); },
  reportDomain: (m) => { return http.post(`console/webcastle/report/domain`, m); }
}

export default report